export const substring = (start: number, end: number) => (a: string) =>
  a.substring(start, a.length - end);
